

export const isRequested = (status?: string) =>
  (status || "").toUpperCase().includes("REQUESTED");

const LOCKED_STATUSES = ["REJECTED", "FULL_REFUNDED"];

export const isLocked = (status?: string) =>
  LOCKED_STATUSES.includes((status || "").toUpperCase());





export const isEditable = (status?: string) => {
  const s = (status || "").toUpperCase();
  if (isRequested(s)) return true;
  if (isLocked(s)) return false;
  return s === "PARTIALLY_REFUNDED";
};

export const refundStatusLabel = (status?: string): string => {
  switch ((status || "").toUpperCase()) {
    case "REQUESTED":
      return "Refund Requested";
    case "PARTIAL_REFUND_REQUESTED":
      return "Partial Refund Requested";
    case "FULL_REFUND_REQUESTED":
      return "Full Refund Requested";
    case "APPROVED":
      return "Approved";
    case "PARTIALLY_REFUNDED":
      return "Partially Refunded";
    case "FULL_REFUNDED":
      return "Fully Refunded";
    case "REJECTED":
      return "Rejected";
    default:
      return status || "-";
  }
};

export const refundStatusColor = (
  status?: string
): "success" | "error" | "warning" | "default" => {
  switch ((status || "").toUpperCase()) {
    case "PARTIALLY_REFUNDED":
    case "FULL_REFUNDED":
    case "APPROVED":
      return "success";
    case "REJECTED":
      return "error";
    case "REQUESTED":
    case "PARTIAL_REFUND_REQUESTED":
    case "FULL_REFUND_REQUESTED":
      return "warning";
    default:
      return "default";
  }
};
